import { onBeforeUnmount } from 'vue';

export function useEcho(channelName: string, channelType: 'private' | 'public' = 'private') {
    const nuxtApp = useNuxtApp();
    const $echo = nuxtApp.$echo;
    const wsEnabled = !!$echo;
    const listeners: { event: string; callback: Function }[] = [];

    const channel = wsEnabled
        ? (channelType === 'private' ? $echo.private(channelName) : $echo.channel(channelName))
        : null;

    const api = {
        listen(event: string, callback: Function) {
            if (channel) {
                channel.listen(event, callback);
                listeners.push({ event, callback });
            }
            return api;
        },

        notification(callback: Function) {
            if (channel) {
                channel.notification(callback);

                listeners.push({
                    event: '.Illuminate\\Notifications\\Events\\BroadcastNotificationCreated',
                    callback
                });
            }
            return api;
        },

        stopListening() {
            listeners.forEach(({ event, callback }) => {
                channel?.stopListening(event, callback);
            });
            listeners.length = 0;
        }
    };

    onBeforeUnmount(() => api.stopListening());

    return api;
}
